import is from 'is_js';

export const validationData = (values, validation) => {
    let errorsData = {}
    Object.keys(validation).map(key => {
        const errorMessage = controlErrorValid(values[key], validation[key])
        if(errorMessage) {
            errorsData[key] = errorMessage
        }
    })
    return errorsData
}

export function controlErrorValid (value, validation) {
    if (!validation) {
        return false
    }

    if (validation.required) {
        if(!value) {
            return "Поле обязательно для заполнения"
        }
        if (!String(value)) {
            return "Поле обязательно для заполнения"
        }
        if (typeof value === 'string' && value.trim() === '') {
            return "Поле обязательно для заполнения"
        } else if(typeof value === 'number' && String(value).length === 0) {
            return "Поле обязательно для заполнения"
        }
    }

    if (validation.email && typeof value === 'string' && value.trim() !== '' && !is.email(value)) {
        return "Введите корректный email"
    }

    if (validation.minLength && String(value).trim() !== '' && String(value).trim().replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '').length < validation.minLength) {
        return `Минимальный размер поля ${validation.minLength}`
    }

    if (validation.maxLength && String(value).trim() !== '' && String(value).trim().replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '').length > validation.maxLength) {
        return `Максимальный размер поля ${validation.maxLength}`
    }

    if (validation.number && !is.number(Number(value))) {
        return "Поле должно быть числом"
    }

    if (typeof validation.minNumber == "number" && Number(value) < +validation.minNumber) {
        console.log('зашло', value, validation.minNumber)
        return `значение не может быть меньше ${validation.minNumber}`
    }

    if (typeof validation.maxNumber == "number" && Number(value) > validation.maxNumber) {
        return `значение не может быть больше ${validation.maxNumber}`
    }

    if (validation.url && typeof value === 'string' && value.trim() !== '' && !is.url(value)) {
        return "Введите корректный url"
    }

    return false
}

const formValid = (value, validation, obj) => {
    //console.log("value",value, obj)
    if (!validation) {
        return true
    }

    if (value === null) {
        value = "";
        console.log("Ошибка валидации. У поля value значение NULL")
    }

    if(value){
        value = value.toString();
    }
    let isValid = true;

    if (validation.emptySelect) {
        isValid = value !== null && value !== "" && isValid
    }

    if (validation.required) {
        if(!value){
            return false
        } else {
            isValid = value.trim() !== '' && isValid
        }
    }

    if (validation.email && value.trim() !== '') {
        isValid = is.email(value) && isValid
    }

    if (validation.minLength) {
        isValid = value.length >= validation.minLength && isValid
    }

    if (validation.number && value.trim() !== '') {
        isValid = is.number(+value) && isValid
    }

    if (validation.notRequiredMinLength && value.trim() !== '') {
        isValid = value.length >= validation.notRequiredMinLength && isValid
    }

    if (validation.ip && value.trim() !== '') {
        isValid = is.ip(value) && isValid
    }

    if (validation.url && value.trim() !== '') {
        isValid = is.url(value) && isValid
    }

    if (validation.website && value.trim() !== '') {
        isValid = is.url(value) && isValid
    }

    if (validation.password && value.trim() !== '') {
        isValid = value.length >= validation.notRequiredMinLength && isValid
    }

    /*if (validation.phone && value.trim() !== '') {
        let phoneno = /^(?:\+?1[-. ]?)?(?:\(?([0-9]{3})\)?[-. ]?)?([0-9]{3})[-. ]?([0-9]{4})$/;
        isValid = value.match(phoneno) && isValid
    }*/


    return isValid
};


export default formValid;